import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import Devices from '.';

const paths = {
  devices: '/devices',
};

export default [
  <RouteIfRights
    exact
    path={paths.devices}
    key={paths.devices}
    component={Devices}
    rights="register"
  />,
];

export { paths };
